// Tells AdButler that the user has seen the ad
const reportViewability = (url?: string): void => {
  if (!url) {
    return;
  }

  if (url) {
    fetch(url);
  }
};

export default reportViewability;
